package ui.home

import androidx.compose.runtime.*
import androidx.compose.ui.graphics.vector.*
import api.*
import common.frontend.api.*
import provider.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.compose.navigation.viewmodel.*
import ui.*
import ui.widget.*

interface HomeScope {

    val vm: HomeVM
    val vmGlobal: GlobalVM
    val nav: Navigation
    val args: ArgsInitial
    val account: CommonAccountProvider
    val login: Io.User
    val action: (HomeVM.Action) -> Unit
    val localization: Localization
    val drawerProvider: HomeDrawerProvider
    val display: CommonDisplayProvider

    companion object {
        @Composable
        fun rememberScope(): HomeScope {
            val nav = LocalNavigation.current
            val vm = nav.viewModel(HomeVM::class)
            val vmGlobal = globalViewModel(GlobalVM::class)
            val action = HomeVM.Action.rememberAction(vm)
            val args = LocalNavigationArgs.current.rememberArgs(ArgsInitial::class)
            val account = LocalAccountProvider.current
            val localization = LocalLocalization.current
            val homeDrawerProvider = LocalHomeDrawerProvider.current
            val display = LocalDisplayProvider.current
            return remember {
                object : HomeScope {
                    override val vm: HomeVM
                        get() = vm
                    override val vmGlobal: GlobalVM
                        get() = vmGlobal
                    override val nav: Navigation
                        get() = nav
                    override val args: ArgsInitial
                        get() = args
                    override val account: CommonAccountProvider
                        get() = account
                    override val login: Io.User
                        get() = account.current!!
                    override val action: (HomeVM.Action) -> Unit
                        get() = action
                    override val localization: Localization
                        get() = localization
                    override val drawerProvider: HomeDrawerProvider
                        get() = homeDrawerProvider
                    override val display: CommonDisplayProvider
                        get() = display


                }.also {
                    vm.init(it)
                }
            }
        }
    }

    class LanguageEntry(
        val entry: LanguageType,
        override val label: String = entry.title,
        override val image: ImageVector? = entry.icon
    ) : DropDownItem {
        companion object {
            val all by lazy {
                LanguageType.allSorted.map { LanguageEntry(it) }
            }
        }
    }
}
